import React, { useEffect, useState } from "react";
import { getValue } from "@utils/lodash";
import { Table } from "reactstrap";
import "@components/Dashboard/ExpandableTable/ExpandableTable.scss";
import { formatDecimal } from "@_common/text-helper";

interface ExpandableTableProps {
	auditUploadLocations: Record<string, string>[];
	handleClickRow: (locationId: string) => void;
	vendorsByLocation: Record<string, string>[];
	headers: any | [];
}

const ExpandableTable: React.FunctionComponent<ExpandableTableProps> = (
	props
) => {
	const { auditUploadLocations, vendorsByLocation, headers } = props;
	const [locationIndex, setLocationIndex] = useState<number | null>(null);

	return (
		<div className="location-wise-table-card">
			<Table>
				<thead>
					<th></th>
					{headers.map((item: any) => (
						<th>{item}</th>
					))}
				</thead>
				<tbody className="location-wise-wrapper__overflow">
					{auditUploadLocations.length > 0 ? (
						auditUploadLocations.map((item, index) => {
							return (
								<>
									<tr
										key={index}
										className={`${
											locationIndex === index
												? "location-wise-table-card__active-row"
												: ""
										}`}
										// onClick={() =>
										// 	props.handleClickRow(getValue(item, `id`, ""))
										// }
									>
										<td
											onClick={() => {
												setLocationIndex(index);
											}}
											className="cursor-pointer"
										>
											{/* <img
												src={`/images/dashboard/tables/${
													locationIndex === index
														? "remove-circle"
														: "add-circle"
												}.svg`}
											/> */}
											
										</td>
										<td>{getValue(item, `location`, "")}</td>
										<td>
											{getValue(
												item,
												`auditData.auditCount.uploaded_count`,
												""
											)}
										</td>
										<td>
											{getValue(
												item,
												`auditData.auditCount.not_uploaded_count`,
												""
											)}
										</td>
										<td>
											{getValue(
												item,
												`auditData.auditCount.complied_count`,
												""
											)}
										</td>
										<td>
											{getValue(
												item,
												`auditData.auditCount.non_complied_count`,
												""
											)}
										</td>
										<td>
											{getValue(
												item,
												`auditData.auditCount.not_applicable_count`,
												""
											)}
										</td>
										<td>
											{getValue(
												item,
												`auditData.auditCount.partially_complied_count`,
												""
											)}
										</td>
										<td>
											{formatDecimal(
												getValue(
													item,
													`auditData.auditScore.compliance_score`,
													""
												)
											)}
											%
										</td>
									</tr>
									{locationIndex === index &&
										vendorsByLocation.length > 0 &&
										vendorsByLocation.map((items, index) => {
											return (
												<tr className="location-wise-table-card__sub-table-info">
													<td
														onClick={() => {
															setLocationIndex(index);
														}}
														className="cursor-pointer"
													>
														<img
															src={`/images/dashboard/tables/${
																locationIndex === index
																	? "remove-circle"
																	: "add-circle"
															}.svg`}
														/>
													</td>
													<td>{getValue(items, `location`, "")}</td>
													<td>
														{getValue(
															items,
															`auditData.auditCount.uploaded_count`,
															""
														)}
													</td>
													<td>
														{getValue(
															items,
															`auditData.auditCount.not_uploaded_count`,
															""
														)}
													</td>
													<td>
														{getValue(
															items,
															`auditData.auditCount.complied_count`,
															""
														)}
													</td>
													<td>
														{getValue(
															items,
															`auditData.auditCount.non_complied_count`,
															""
														)}
													</td>
													<td>
														{getValue(
															items,
															`auditData.auditCount.not_applicable_count`,
															""
														)}
													</td>
													<td>
														{getValue(
															items,
															`auditData.auditCount.partially_complied_count`,
															""
														)}
													</td>
													<td>
														{formatDecimal(
															getValue(
																items,
																`auditData.auditScore.compliance_score`,
																""
															)
														)}
														%
													</td>
												</tr>
											);
										})}
								</>
							);
						})
					) : (
						<tr>
							<td></td>
							<td></td>
							<td></td>
							<td></td>
							<td>No Data Found</td>
							<td></td>
							<td></td>
							<td></td>
						</tr>
					)}
				</tbody>
			</Table>
		</div>
	);
};

export default ExpandableTable;
